import React from 'react';
export const Contract = () => (
  <svg width="201px" height="157px" viewBox="0 0 201 157" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-763.000000, -509.000000)">
        <g transform="translate(763.000000, 509.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M175.4141,152.2074 L143.6691,152.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M56.5831,152.2074 L37.8271,152.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.8267,152.2074 L9.7907,152.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(65.000000, 57.710000)">
            <path
              d="M24.8521,3.5814 C24.8521,3.5814 6.5831,6.6174 3.6231,6.8684 C0.6621,7.1194 -0.1719,10.4914 0.2661,13.3074 L42.4141,6.7684 C41.7801,2.6924 45.7701,0.3294 45.7701,0.3294 L24.8521,3.5814"
              fill="#FFFFFF"
            />
            <path
              d="M24.8521,3.5814 C24.8521,3.5814 6.5831,6.6174 3.6231,6.8684 C0.6621,7.1194 -0.1719,10.4914 0.2661,13.3074 L42.4141,6.7684 C41.7801,2.6924 45.7701,0.3294 45.7701,0.3294 L24.8521,3.5814"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(68.000000, 57.710000)">
            <path
              d="M8.0587,42.7738 C9.5057,53.4878 10.8667,63.1998 11.2507,64.5828 C12.1167,67.6908 15.4017,66.8488 15.4017,66.8488 L59.2737,60.0298 C59.2737,60.0298 56.0527,59.2108 55.5367,55.8858 C55.0197,52.5618 48.2547,3.5928 48.2547,3.5928 C48.2547,3.5928 48.2927,-0.3932 44.2467,0.2358 C40.2007,0.8648 -2.9373,7.3598 0.7177,6.8088 C3.1127,6.4488 3.7487,10.8768 3.9587,12.2208 C4.2007,13.7668 5.2107,21.4418 6.4117,30.4688"
              fill="#FFFFFF"
            />
            <path
              d="M8.0587,42.7738 C9.5057,53.4878 10.8667,63.1998 11.2507,64.5828 C12.1167,67.6908 15.4017,66.8488 15.4017,66.8488 L59.2737,60.0298 C59.2737,60.0298 56.0527,59.2108 55.5367,55.8858 C55.0197,52.5618 48.2547,3.5928 48.2547,3.5928 C48.2547,3.5928 48.2927,-0.3932 44.2467,0.2358 C40.2007,0.8648 -2.9373,7.3598 0.7177,6.8088 C3.1127,6.4488 3.7487,10.8768 3.9587,12.2208 C4.2007,13.7668 5.2107,21.4418 6.4117,30.4688"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M112.6348,95.0776 L85.2248,99.0286 C84.6278,99.1146 84.0698,98.6966 83.9838,98.0996 C83.8978,97.5036 84.3158,96.9446 84.9118,96.8586 L112.3228,92.9076 C112.9188,92.8216 113.4768,93.2396 113.5628,93.8366 C113.6488,94.4326 113.2318,94.9916 112.6348,95.0776"
            fill="#DDE5E8"
          />
          <path
            d="M111.774,89.1059 L84.364,93.0569 C83.767,93.1429 83.209,92.7249 83.123,92.1289 C83.037,91.5329 83.455,90.9739 84.051,90.8879 L111.462,86.9369 C112.058,86.8509 112.616,87.2679 112.702,87.8649 C112.788,88.4609 112.371,89.0199 111.774,89.1059"
            fill="#DDE5E8"
          />
          <path
            d="M110.8438,83.5541 L83.4328,87.5051 C82.8368,87.5911 82.2788,87.1731 82.1928,86.5771 C82.1068,85.9811 82.5238,85.4221 83.1208,85.3361 L110.5308,81.3851 C111.1278,81.2991 111.6858,81.7171 111.7718,82.3131 C111.8578,82.9091 111.4398,83.4681 110.8438,83.5541"
            fill="#DDE5E8"
          />
          <path
            d="M103.147,102.5883 L86.106,105.0443 C85.51,105.1303 84.951,104.7133 84.865,104.1163 C84.779,103.5203 85.197,102.9613 85.793,102.8753 L102.834,100.4193 C103.431,100.3333 103.989,100.7503 104.075,101.3473 C104.161,101.9433 103.744,102.5023 103.147,102.5883"
            fill="#DDE5E8"
          />
          <polygon
            fill="#FFFFFF"
            points="109.7149 67.1361 79.9279 71.4301 81.1659 80.0121 110.9519 75.7181"
          />
          <polygon
            stroke="#DDE5E8"
            points="109.7149 67.1361 79.9279 71.4301 81.1659 80.0121 110.9519 75.7181"
          />
          <g transform="translate(100.000000, 112.710000)">
            <path d="M0.3892,2.7416 L17.9062,0.0486" fill="#FFFFFF" />
            <path
              d="M0.3892,2.7416 L17.9062,0.0486"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="2,3"
            />
          </g>
          <path
            d="M94.0689,113.3979 L97.1619,115.4409"
            stroke="#CCD82B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M121.6207,84.7475 C121.6207,84.7475 129.4397,94.0035 123.3237,104.5495 L116.3307,103.6015 L112.7227,96.5925 L116.8767,86.6045 L121.6207,84.7475 Z"
            fill="#FFFFFF"
          />
          <path
            d="M121.6207,84.7475 C121.6207,84.7475 129.4397,94.0035 123.3237,104.5495 L116.3307,103.6015 L112.7227,96.5925 L116.8767,86.6045 L121.6207,84.7475 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.6343,112.9652 L94.6633,115.7832"
            stroke="#CCD82B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.4424,100.7719 C126.2714,104.0959 121.0064,104.2209 117.6824,101.0499 C114.3584,97.8789 114.2344,92.6149 117.4044,89.2909 C120.5754,85.9659 125.8404,85.8419 129.1644,89.0119 C132.4884,92.1829 132.6134,97.4479 129.4424,100.7719 M114.9114,86.9129 C110.4274,91.6139 110.6034,99.0589 115.3044,103.5429 C120.0054,108.0269 127.4514,107.8509 131.9354,103.1499 C136.4194,98.4499 136.2434,91.0029 131.5424,86.5189 C126.8414,82.0359 119.3954,82.2109 114.9114,86.9129"
            fill="#AA81F7"
          />
          <path
            d="M131.9356,103.1498 L135.1516,106.2178"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.5318,111.5512 L140.7808,112.3392 C140.1648,112.9852 139.1348,113.0082 138.4898,112.3942 L133.7858,107.9062 C133.1408,107.2912 133.1158,106.2612 133.7318,105.6162 L134.4838,104.8272 C135.0978,104.1832 136.1288,104.1582 136.7738,104.7742 L141.4778,109.2612 C142.1228,109.8762 142.1468,110.9062 141.5318,111.5512"
            fill="#FFFFFF"
          />
          <path
            d="M141.5318,111.5512 L140.7808,112.3392 C140.1648,112.9852 139.1348,113.0082 138.4898,112.3942 L133.7858,107.9062 C133.1408,107.2912 133.1158,106.2612 133.7318,105.6162 L134.4838,104.8272 C135.0978,104.1832 136.1288,104.1582 136.7738,104.7742 L141.4778,109.2612 C142.1228,109.8762 142.1468,110.9062 141.5318,111.5512 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M137.129,111.0951 L140.117,107.9621"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.4424,100.7719 C126.2714,104.0959 121.0064,104.2209 117.6824,101.0499 C114.3584,97.8789 114.2344,92.6149 117.4044,89.2909 C120.5754,85.9659 125.8404,85.8419 129.1644,89.0119 C132.4884,92.1829 132.6134,97.4479 129.4424,100.7719 Z M126.3504,83.6359 C122.3624,82.6159 117.9554,83.7219 114.9114,86.9129 C110.4274,91.6139 110.6034,99.0589 115.3044,103.5429 C120.0054,108.0269 127.4514,107.8509 131.9354,103.1499 C133.3164,101.7039 134.2544,99.9959 134.7554,98.1949 L126.3504,83.6359 Z M134.9494,92.6769 C134.4874,90.4029 133.3494,88.2429 131.5424,86.5189 C130.0324,85.0789 128.2384,84.1189 126.3504,83.6359 L134.9494,92.6769 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M130.4722,65.0434 L130.4722,66.3584"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M130.4722,68.9897 L130.4722,70.3047"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M133.1036,67.6742 L131.7886,67.6742"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M129.1568,67.6742 L127.8418,67.6742"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M137.7921,76.9672 C137.7921,77.4502 137.4011,77.8412 136.9181,77.8412 C136.4361,77.8412 136.0441,77.4502 136.0441,76.9672 C136.0441,76.4852 136.4361,76.0942 136.9181,76.0942 C137.4011,76.0942 137.7921,76.4852 137.7921,76.9672"
            fill="#D62793"
          />
          <path
            d="M69.3721,109.5287 C69.3721,110.0117 68.9801,110.4027 68.4981,110.4027 C68.0151,110.4027 67.6241,110.0117 67.6241,109.5287 C67.6241,109.0467 68.0151,108.6557 68.4981,108.6557 C68.9801,108.6557 69.3721,109.0467 69.3721,109.5287"
            fill="#0B9CE5"
          />
          <path
            d="M64.9981,120.3569 L64.9981,122.1069"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M64.9981,125.6069 L64.9981,127.3569"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M68.4981,123.8569 L66.7481,123.8569"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M63.2481,123.8569 L61.4981,123.8569"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M119.2286,152.3178 C119.2286,154.6278 111.5606,156.5008 102.1026,156.5008 C92.6436,156.5008 84.9766,154.6278 84.9766,152.3178 C84.9766,150.0078 92.6436,148.1358 102.1026,148.1358 C111.5606,148.1358 119.2286,150.0078 119.2286,152.3178"
            fill="#D0D7DA"
          />
          <path
            d="M61.5201,91.8842 L60.6181,92.6632 C59.7861,93.3832 58.5171,93.2902 57.7971,92.4582 L47.0371,80.0082 C46.3181,79.1762 46.4101,77.9062 47.2431,77.1882 L48.1441,76.4082 C48.9771,75.6892 50.2461,75.7812 50.9651,76.6132 L61.7261,89.0632 C62.4451,89.8952 62.3531,91.1642 61.5201,91.8842"
            fill="#FFFFFF"
          />
          <path
            d="M61.5201,91.8842 L60.6181,92.6632 C59.7861,93.3832 58.5171,93.2902 57.7971,92.4582 L47.0371,80.0082 C46.3181,79.1762 46.4101,77.9062 47.2431,77.1882 L48.1441,76.4082 C48.9771,75.6892 50.2461,75.7812 50.9651,76.6132 L61.7261,89.0632 C62.4451,89.8952 62.3531,91.1642 61.5201,91.8842 Z"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.9791,88.3695 L57.9431,86.6725"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.0694,92.2738 L62.1914,93.5718"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="52.4864 80.4135 47.2264 74.3285 46.2444 75.1775 47.5784 76.7205"
          />
          <path
            d="M64.7657,94.8695 C68.2617,94.6915 71.0697,91.7525 74.5257,91.1955 C74.6677,91.1735 74.8217,91.1555 74.9507,91.2215 C75.2687,91.3805 75.1897,91.8505 75.0617,92.1825 C74.4117,93.8875 72.5067,95.8345 73.1087,97.2955 C73.7117,98.7565 76.4077,96.6985 77.9427,96.0385"
            stroke="#F5C400"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
